import isNil from "lodash.isnil";

class SettingsLocalStorageServiceClass {
  constructor() {
    this.cartSessionName = $("#CART_SESSION_NAME").val();
    this.initShowVAT();
  }

  initShowVAT() {
    const showVATStored = localStorage.getItem(
      `showVAT-${this.cartSessionName}`
    );

    if (isNil(showVATStored)) {
      const result = showVATStored
        ? JSON.parse(showVATStored)
        : $("#WITH_VAT").val() === "false"
        ? false
        : true;
      this.setShowVAT(result);
    }
  }

  getShowVAT() {
    return JSON.parse(localStorage.getItem(`showVAT-${this.cartSessionName}`));
  }

  setShowVAT(value) {
    localStorage.setItem(
      `showVAT-${this.cartSessionName}`,
      JSON.stringify(value)
    );
  }
}

export const settingsLocalStorageService =
  new SettingsLocalStorageServiceClass();
